export default "__VITE_ASSET__C59x_VST__"